import { Component, inject } from '@angular/core';
import { AuthService } from '@app/services/auth.service';
import { VersionService } from '@app/services/version.service';
import { UserIconComponent } from '@app/profile/user-icon/user-icon.component';
import { RedDotComponent } from '@app/version/red-dot.component';
import { UserMenuComponent } from './user-menu.component';
import { Popover } from 'primeng/popover';

@Component({
  selector: 'app-user-menu-trigger',
  standalone: true,
  imports: [UserIconComponent, RedDotComponent, Popover, UserMenuComponent],
  template: `
    @if (authService.currentUser()) {
      <button
        class="relative flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-black"
        (click)="op.toggle($event)"
        data-testid="open-menu-button">
        <app-user-icon />
        <app-red-dot
          [visible]="versionService.versionIsBrandNew() || versionService.updateAvailable()"
          styleClass="animate-bounce right-1 top-1 !h-[14px] !w-[14px]" />
      </button>
    }
    <p-popover #op styleClass="user-menu-popover" [style]="{ width: 'min(280px, 100vw)' }">
      @if (authService.currentUser()) {
        <app-user-menu (click)="onMenuClick($event, op)" />
      }
    </p-popover>
  `,
})
export class UserMenuTriggerComponent {
  authService = inject(AuthService);
  versionService = inject(VersionService);

  onMenuClick(event: MouseEvent, op: Popover): void {
    if ((event.target as HTMLElement).closest('button, a')) {
      op.hide();
    }
  }
}
